export class GaEvents {
    static initiated = false;
    static storage = [];

    static EVENT1_PHONE = 'phone';

    static EVENT2_CREDIT = 'credit_button';
    static EVENT3_CREDIT = 'credit_form';

    static EVENT4_RESERVE = 'reserve_button';
    static EVENT5_RESERVE = 'reserve_form';

    static EVENT6_TRADEIN = 'tradein_button';
    static EVENT7_TRADEIN = 'tradein_form';

    static EVENT8_CREDIT = 'credit_page_form';
    static EVENT9_TRADEIN = 'tradein_page_form';

    static EVENT10_GETOFFER = 'get_offer_form';

    static EVENT11_WIDGET = 'video_widget_form';

    static init() {
        let interval = setInterval(() => {
            if(window.gtag) {
                GaEvents.initiated = true;
                console.log('GaEvents:initiated');
                GaEvents.trySend();
                clearInterval(interval);
            }
        },500);
    }

    static send(eventName) {
        GaEvents.storage.push(eventName);
        GaEvents.trySend();
    }

    static trySend() {
        if(GaEvents.initiated) {
            let len = GaEvents.storage.length;
            while(GaEvents.storage.length) {
                try {
                    let eventName = GaEvents.storage.shift();
                    window.gtag('event', eventName);
                    console.log(`GaEvents:sended ${eventName}`);
                } catch (e) {
                    console.error('GaEvents:send', e);
                }
            }
            console.log(`GaEvents:sended ${len}`);
        }
    }
}
